/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill, .bg {
    color: inherit;
  }
`
export default class QuestionMarkIco extends PureComponent {
  render() {
    return (
      <svg id="information" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" css={Color}>
        <g id="그룹_12261" data-name="그룹 12261">
          <circle id="타원_692" className="bg" data-name="타원 692" cx="7" cy="7" r="7" fill="#c9c9c9"/>
          <path id="패스_9358" className="fill" data-name="패스 9358" d="M1.627-1.613a2.846,2.846,0,0,1,.161-1.056,2.167,2.167,0,0,1,.589-.774,3.012,3.012,0,0,0,.57-.621.974.974,0,0,0,.142-.5q0-.8-.738-.8a.748.748,0,0,0-.561.216.848.848,0,0,0-.22.6H.2A1.825,1.825,0,0,1,.782-5.975,2.275,2.275,0,0,1,2.35-6.486,2.285,2.285,0,0,1,3.907-6,1.727,1.727,0,0,1,4.461-4.63a1.669,1.669,0,0,1-.18.76,3.131,3.131,0,0,1-.629.793l-.383.365a1.3,1.3,0,0,0-.412.81l-.019.289ZM1.489-.163A.689.689,0,0,1,1.7-.684a.766.766,0,0,1,.551-.205.766.766,0,0,1,.551.205.689.689,0,0,1,.215.521.683.683,0,0,1-.211.514.768.768,0,0,1-.556.2A.768.768,0,0,1,1.7.351.683.683,0,0,1,1.489-.163Z" transform="translate(4.702 10.26)" fill="#929292"/>
        </g>
      </svg>
    )
  }
}
